import { useEffect } from "react";
import { useSelector } from "react-redux";

function useGetJsonByApplicationNLang(applicationFieldName, callback) {
    const application = useSelector(state => state.application);
    const lang = useSelector(state => state.translate.lang);

    useEffect(() => {
        const getJsonByApplicationNLang = async () => {
            if (application.applicationId && lang && applicationFieldName) {
                const curriculumsJsonUrl = application[applicationFieldName]
                let res = await fetch(curriculumsJsonUrl.replace('lang', lang))
                let resJson = null
                if (res) {
                    resJson = await res.json();
                }

                if (callback)
                    callback(resJson);
            }
        }
        getJsonByApplicationNLang()

    }, [application.applicationId, lang, applicationFieldName]);
}

export default useGetJsonByApplicationNLang;